import React from "react";
import { FiCompass, FiSearch, FiMessageSquare, FiEyeOff, FiGrid } from "react-icons/fi";
import type { WalkthroughTaskId } from "./walkthroughProgress";
import { QUICK_ACTIONS_SHORTCUT_LABEL } from "./platform";

export interface WalkthroughTask {
  id: WalkthroughTaskId;
  label: string;
  icon: React.ReactNode;
  /** Present only for tasks the user can act on directly from the walkthrough
   * (e.g. jump to Ask AI). Tasks without one are status only — they complete
   * as a side effect of using the product, not by clicking the row. */
  action?: { label: string };
}

export interface WalkthroughGroup {
  label: string;
  tasks: WalkthroughTask[];
}

export const WALKTHROUGH_GROUPS: WalkthroughGroup[] = [
  {
    label: "Getting started",
    tasks: [
      { id: "opened-with-shortcut", label: `Open Quick Actions with ${QUICK_ACTIONS_SHORTCUT_LABEL}`, icon: <FiCompass size={13} /> },
      { id: "jumped-to-something", label: "Jump straight to a Center or workspace", icon: <FiGrid size={13} /> },
      { id: "searched-by-typing", label: "Find something by typing a few letters", icon: <FiSearch size={13} /> },
    ],
  },
  {
    label: "Beyond the basics",
    tasks: [
      { id: "asked-ai", label: "Ask AI a question from Quick Actions", icon: <FiMessageSquare size={13} />, action: { label: "Ask AI" } },
      { id: "hid-a-workspace", label: "Tidy your nav by hiding a workspace you don't use", icon: <FiEyeOff size={13} />, action: { label: "Show hidden" } },
      { id: "visited-every-center", label: "Visit every Center at least once", icon: <FiGrid size={13} />, action: { label: "Go to one" } },
    ],
  },
];

export const TOTAL_WALKTHROUGH_TASKS = WALKTHROUGH_GROUPS.reduce((n, g) => n + g.tasks.length, 0);
